<app-view-item *ngIf="disabled" [text]="selected?.code"></app-view-item>

<div class="cust-bir-select-container" *ngIf="!disabled">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="true" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)" [nzCustomTemplate]="displayTpl"
    [(ngModel)]="value" (ngModelChange)="selectBir($event)" [nzDropdownMatchSelectWidth]="false"
    nzDropdownClassName="dropdownSelect" [nzDisabled]="disabled" class="width-180">
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <nz-option *ngIf="!searching && showAddNewButton" [nzValue]="''" nzCustomContent>
      <div class="text-center" *ngIf="!this.NotShowInReport">
        <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
          <span nz-icon nzType="plus"></span>
          {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
        </button>
      </div>
    </nz-option>

    <ng-container *ngFor="let item of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(item)" [nzLabel]="item.code" nzCustomContent>
        <app-bir-select-item [bir]="item"></app-bir-select-item>
      </nz-option>
    </ng-container>
  </nz-select>

  <div class="edit-button-container">
    <button type="button" nz-button [disabled]="!value" (click)="editBir()">
      <span nz-icon nzType="edit" nzTheme="outline"></span>
    </button>
  </div>
</div>

<app-bir-exist-modal (selectBir)="selectBir($event)"></app-bir-exist-modal>
<app-bir-edit-modal (selectBir)="selectBir($event)" [forceAR]="true"></app-bir-edit-modal>
<app-bir-replace-modal (selectBir)="replaceBir($event)"></app-bir-replace-modal>